import React from "react";
import AddIcon from "@material-ui/icons/Add";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field, FieldArray } from "formik";
import PropertySection from "../property/PropertySection";
import memoAssign from "../../util/memoAssign";
import { AddPropertyFieldComponent } from "../property/PropertyField";

const addRowToolbarStyles = theme => ({
  leftIcon: {
    marginRight: theme.spacing(1)
  }
});

const AddRowButton = withStyles(addRowToolbarStyles, {
  name: "LcRowListFieldAddRowButton"
})(({ classes, onClick, label, FieldAddIcon, variant, disabled }) => (
  <Toolbar>
    <Button variant={variant} onClick={onClick} disabled={disabled}>
      <FieldAddIcon fontSize="small" className={classes.leftIcon} />
      {label}
    </Button>
  </Toolbar>
));

export const RowListField = withStyles(
  {
    closeMenuIcon: {
      marginLeft: "auto"
    }
  },
  { name: "LcRowListField" }
)(function RowListField({
  //formik,
  classes,
  name,
  fieldInfo = {},
  sections = [],
  add: { icon: FieldAddIcon = AddIcon, label: addLabel = "Add" } = {},
  delete: { icon: FieldDeleteIcon = DeleteForeverIcon } = {},
  max = -1,
  header = {
    //paddingBottom: 1
  },
  section = {
    //paddingBottom: 0,
    //marginBottom: 2,
    //marginRight: 1,
    //border: 1,
    //borderColor: "#ced4da",
    //padding: 2,
    //borderRadius: ".25rem"
  },
  field = {
    //padding: 0.25,
    //paddingBottom: 1
  },
  readOnly = false,
  defaultValues = {},
  disabled,
  //direction = "row",
  //title = {
  //layout: [["title"]],
  //fieldInfo: {
  //title: {
  //label: "Title"
  //}
  //}
  //},
  hideRemove,
  dense,
  value,
  fast = true,
  FieldComponent = fast ? FastField : Field
}) {
  return (
    <FieldComponent name={name}>
      {({ field: { value: fieldVal }, form }) => {
        const dis = form.isSubmitting || form.isValidating || disabled;
        const items = value || fieldVal;
        if (!items) return null;

        return (
          items && (
            <FieldArray
              name={name}
              render={arrayHelpers => (
                <>
                  {items.map((item, idx) => {
                    let p;
                    p = name + "[" + idx + "]";

                    const sectionListItems =
                      sections &&
                      sections.map(
                        (
                          {
                            hidden,
                            box = {},
                            field: sectionField = {},
                            header: sectionHeader = {},
                            ...sectionEntry
                          },
                          sectionIdx
                        ) => {
                          const shouldHide =
                            hidden !== undefined && hidden(form.values, form);

                          const key = p + "#" + sectionIdx;

                          return (
                            <ListItem key={key}>
                              <Box
                                flexGrow={1}
                                mr={2}
                                {...{ ...(section || {}), ...(box || {}) }}
                              >
                                <PropertySection
                                  shouldHide={shouldHide}
                                  fieldInfo={fieldInfo}
                                  {...sectionEntry}
                                  header={memoAssign(header, sectionHeader)}
                                  field={memoAssign(field, sectionField)}
                                  prefix={p}
                                />
                              </Box>
                              {!hideRemove && (
                                <IconButton
                                  className={classes.closeMenuIcon}
                                  onClick={() => {
                                    //e.stopPropagation();
                                    form.setFieldError(name, undefined);
                                    arrayHelpers.remove(idx);
                                  }}
                                >
                                  <FieldDeleteIcon />
                                </IconButton>
                              )}
                            </ListItem>
                          );
                        }
                      );

                    const panel = (
                      <List dense={dense} key={p}>
                        {sectionListItems}
                      </List>
                    );

                    return panel;
                  })}
                  {!readOnly && (max === -1 || max > items.length) && (
                    <AddRowButton
                      disabled={dis}
                      onClick={() => {
                        arrayHelpers.push(defaultValues);
                      }}
                      label={addLabel}
                      FieldAddIcon={FieldAddIcon}
                    />
                  )}
                </>
              )}
            />
          )
        );
      }}
    </FieldComponent>
  );
});

AddPropertyFieldComponent("rowlist", RowListField);

export default RowListField;
